/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AppointmentsService {
    /**
     * List all appointments
     * Get a paginated list of appointments for the authenticated user
     * @param clientId Filter by client ID
     * @param dateFrom Filter by date from
     * @returns any List of appointments
     * @throws ApiError
     */
    public static bb7Eecafa9F5D72B005274A851Db91Ea(
        clientId?: number,
        dateFrom?: string,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/appointments',
            query: {
                'client_id': clientId,
                'date_from': dateFrom,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create a new appointment
     * Create a new appointment
     * @param requestBody
     * @returns any Appointment created successfully
     * @throws ApiError
     */
    public static ad67700Abe95E180Abd8D79890Eaa7B8(
        requestBody: {
            client_id: number;
            department_id?: number | null;
            type: string;
            date: string;
            time: string;
            name: string;
            mobile?: string | null;
            note?: string | null;
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/appointments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get a specific appointment
     * Retrieve details of a specific appointment
     * @param id Appointment ID
     * @returns any Appointment details
     * @throws ApiError
     */
    public static abb6Faa60A95A5C5293F3C4D2B3248(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/appointments/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Appointment not found`,
            },
        });
    }
    /**
     * Update an appointment
     * Update an existing appointment
     * @param id Appointment ID
     * @param requestBody
     * @returns any Appointment updated successfully
     * @throws ApiError
     */
    public static af74D8A4523B36Eb424D4B4D1463Cc9(
        id: number,
        requestBody: {
            client_id?: number;
            date?: string;
            time?: string;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/appointments/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                404: `Appointment not found`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Delete an appointment
     * Delete an appointment
     * @param id Appointment ID
     * @returns any Appointment deleted successfully
     * @throws ApiError
     */
    public static f66861F831376E0Db79C07F3(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/appointments/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Appointment not found`,
            },
        });
    }
}
